import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditSchool from '../../components/schools/FormAddEditSchool';
import { useParams } from 'react-router-dom';
import { useGetSchool } from '../../hooks/schools/useGetSchool';
import LoadingPage from '../../components/global/LoadingPage';

const EditSchool = () => {
    const { id } = useParams();
    const { school, isLoading } = useGetSchool(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSchool isEdit currentData={school?.data} />
        </WrapperSection>
    );
};

export default EditSchool;
